
import PrivacyPolicy from "./company/PrivacyPolicy";

export { Page }

function Page() {
  return <PrivacyPolicy />;
}
